import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-time-picker-bootstrap',
  templateUrl: './time-picker-bootstrap.component.html',
  styleUrls: ['./time-picker-bootstrap.component.css']
})
export class TimePickerBootstrapComponent implements OnInit {
	displayError = false;
	@Input() model: NewTimePicker = {
		placeholder: '',
		readonly: false,
		// errorMessage: 'Batch Timing is required'
		// value: new Date()
	}
	@Output() timeOutput = new EventEmitter<NewTimePicker>();


	public min: Date = new Date(2000, 2, 10, 2, 30);
	public max: Date = new Date(2002, 2, 10, 22, 15);
	// public value: Date = new Date(2000, 2, 10, 10, 0);

  constructor() { }

  ngOnInit() {
  }

  onTimeChange(event) {
	console.log(event);
	  console.log(this.model.value);
	this.timeOutput.emit(this.model);
  }

	onClick() {
		this.model.displayError = true;
  	}

}

export interface NewTimePicker {
	min?: Date, max?: Date, disabled?: boolean, readonly?: boolean, required?: boolean, placeholder?: string, value?: Date,
	errorMessage?: string, displayError?: boolean
}
